import type { OrderStatus } from '@palihog/shared';

export const statusLabels: Record<OrderStatus, string> = {
  submitted: 'Submitted', under_review: 'Under review', awaiting_customer_approval: 'Awaiting customer approval',
  confirmed: 'Confirmed', assigned: 'Rider assigned', accepted: 'Rider accepted',
  purchasing_or_collecting: 'Purchasing / collecting', picked_up: 'Picked up', on_the_way: 'On the way',
  delivered: 'Delivered', completed: 'Completed', rejected: 'Rejected', cancelled: 'Cancelled', delivery_failed: 'Delivery failed',
};

export function StatusBadge({ status }: { status: OrderStatus }) {
  return <span className={`status status-${status}`}>{statusLabels[status]}</span>;
}
